// Populate this file with whatever state you want the app to start with.
// Be sure to not commit the data you put in this file for testing.
export default {}



// WEBPACK FOOTER //
// ./assets/redux/initialState.js